/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_OwnerInputs */



/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Explorer_Info_Property_OwnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_owner = /** @type {((inputs?: Explorer_Info_Property_OwnerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_OwnerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proprietaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigentümer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Владелец")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dueño")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("所有者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मालिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Proprietário")
	return /** @type {LocalizedString} */ ("Owner")
});